import { useRef, useState } from "react";
import { Upload, X, Loader2, ImageIcon } from "lucide-react";
import { api, API_BASE, resolveAssetUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export default function ImageUploader({ value, onChange, label = "Image", testid }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    setBusy(true);
    try {
      const form = new FormData(); form.append("file", file);
      const t = localStorage.getItem("tara_token");
      const res = await fetch(`${API_BASE}/admin/upload`, {
        method: "POST", body: form, credentials: "include",
        headers: t ? { Authorization: `Bearer ${t}` } : {},
      });
      if (!res.ok) throw new Error((await res.json()).detail || "Upload failed");
      const data = await res.json();
      onChange?.(data.url);
      toast.success("Uploaded");
    } catch (e) {
      toast.error(e.message || "Upload failed");
    } finally { setBusy(false); }
  };

  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (f) upload(f);
    e.target.value = "";
  };

  const previewUrl = value ? resolveAssetUrl(value) : "";

  return (
    <div className="space-y-2">
      <div className="text-xs uppercase tracking-wider text-ink-muted">{label}</div>
      <div className="flex items-start gap-3">
        <div className="h-20 w-20 rounded-xl bg-slate-100 border border-slate-200 grid place-items-center overflow-hidden shrink-0">
          {previewUrl ? <img src={previewUrl} alt="" className="h-full w-full object-cover"/> : <ImageIcon className="h-6 w-6 text-slate-400"/>}
        </div>
        <div className="flex-1 space-y-2">
          <div className="flex gap-2">
            <Button type="button" variant="outline" size="sm" data-testid={testid ? `${testid}-upload` : undefined}
              disabled={busy} onClick={() => ref.current?.click()}>
              {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin"/> : <Upload className="h-4 w-4 mr-2"/>}
              Upload
            </Button>
            {value && (
              <Button type="button" variant="ghost" size="sm" onClick={() => onChange?.("")} data-testid={testid ? `${testid}-clear` : undefined}>
                <X className="h-4 w-4 mr-1"/> Remove
              </Button>
            )}
          </div>
          <Input data-testid={testid ? `${testid}-url` : undefined} value={value || ""} onChange={e => onChange?.(e.target.value)} placeholder="…or paste URL" className="h-9 text-xs"/>
          <input ref={ref} type="file" accept="image/*" className="hidden" onChange={onFile}/>
        </div>
      </div>
    </div>
  );
}
